import { FacebookChannelType } from './facebook-channel-type.enum';
var FacebookChannelDataBuilder = /** @class */ (function () {
    function FacebookChannelDataBuilder() {
        this.facebookChannelData = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            pageId: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0c',
            parentId: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0d',
            postId: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0e',
            time: Date.now(),
            type: FacebookChannelType.POST,
            url: 'https://www.facebook.com'
        };
    }
    FacebookChannelDataBuilder.prototype.withId = function (id) {
        this.facebookChannelData.id = id;
        return this;
    };
    FacebookChannelDataBuilder.prototype.withPageId = function (pageId) {
        this.facebookChannelData.pageId = pageId;
        return this;
    };
    FacebookChannelDataBuilder.prototype.withParentId = function (parentId) {
        this.facebookChannelData.parentId = parentId;
        return this;
    };
    FacebookChannelDataBuilder.prototype.withPostId = function (postId) {
        this.facebookChannelData.postId = postId;
        return this;
    };
    FacebookChannelDataBuilder.prototype.withUrl = function (url) {
        this.facebookChannelData.url = url;
        return this;
    };
    FacebookChannelDataBuilder.prototype.withTime = function (time) {
        this.facebookChannelData.time = time;
        return this;
    };
    FacebookChannelDataBuilder.prototype.withType = function (type) {
        this.facebookChannelData.type = type;
        return this;
    };
    FacebookChannelDataBuilder.prototype.build = function () {
        return this.facebookChannelData;
    };
    return FacebookChannelDataBuilder;
}());
export { FacebookChannelDataBuilder };
//# sourceMappingURL=facebook-channel-data.builder.js.map